/** @jsxImportSource theme-ui */
import React from 'react';
import { useSelector } from 'react-redux';

import { InsightsState } from 'app-redux/InsightsState';

import { Typography } from 'components/_common/Typography';
import BdPngExportHeader from 'components/_controls/PngExports/BdPngExportHeader';

import diseasesSelectors from 'diseases/diseases.selectors';
import RiskOverviewCardPreventabilityDetails from 'riskOverview/components/RiskOverviewCardPreventabilityDetails';
import RiskOverviewCardSeverityDetails from 'riskOverview/components/RiskOverviewCardSeverityDetails';
import RiskOverviewCardTransmissibilityDetails from 'riskOverview/components/RiskOverviewCardTransmissibilityDetails';
import riskOverviewSelectors from 'riskOverview/riskOverview.selectors';

import RiskOverviewCardLandscapeContainer from './RiskOverviewCardLandscapeContainer';

type RiskOverviewCardDisruptionLandscapeProps = {
  header: string;
  locationId: number;
  activityId: number;
};

const RiskOverviewCardDisruptionLandscape: React.FC<RiskOverviewCardDisruptionLandscapeProps> = ({
  header,
  locationId,
  activityId,
}) => {
  const riskFeedEntry = useSelector((state: InsightsState) =>
    riskOverviewSelectors.getRiskFeedEntryByActivityIdAndLocationId(state)
  )(activityId, locationId);

  const diseaseName = useSelector(diseasesSelectors.getDiseaseName(riskFeedEntry?.diseaseId));

  return (
    <RiskOverviewCardLandscapeContainer>
      <BdPngExportHeader title={header} superTitle="Your risk of" supertitleVariant="overline" />
      <Typography variant="h6" color="stone90" sx={{ mt: '32px' }}>
        Risk of Disruption – {diseaseName} Risk Factors
      </Typography>
      <div
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          columnGap: '32px',
          '& .ro-card-disrupt-factor-container': {
            display: 'flex',
            flexDirection: 'column',
            borderBottom: 'none',
            '& .icon-column': {
              width: '100%',
              margin: 0,
              mb: '32px',
            },
            '& .detail-column': {
              width: '100%',
              margin: 0,
              '& li': { pl: '4px' },
            },
          },
        }}
      >
        <div sx={{ gridColumn: '1' }}>
          <RiskOverviewCardTransmissibilityDetails
            locationId={locationId}
            diseaseActivityId={activityId}
          />
        </div>
        <div sx={{ gridColumn: '2' }}>
          <RiskOverviewCardPreventabilityDetails
            locationId={locationId}
            diseaseActivityId={activityId}
          />
        </div>
        <div sx={{ gridColumn: '3' }}>
          <RiskOverviewCardSeverityDetails locationId={locationId} diseaseActivityId={activityId} />
        </div>
      </div>
    </RiskOverviewCardLandscapeContainer>
  );
};

export default RiskOverviewCardDisruptionLandscape;
